import { IrisBase } from '@/models/iris/IrisBase'
import { getDefaultAisEnable, IAisEnable } from '@/models/iris/ais/IAisEnable'
import { getDefaultAisParams, IAisParams } from '@/models/iris/ais/IAisParams'
import { getDefaultAisAnticoll, IAisAnticoll } from './IAisAnticoll'

export interface IAisConfig extends IrisBase {
  EnabledMOD: IAisEnable
  ANTICOLL: IAisAnticoll    
  AIS: IAisParams
}

export const getDefaultAisConfig = ():IAisConfig => {
    return {        
        EnabledMOD:getDefaultAisEnable(),
        ANTICOLL:getDefaultAisAnticoll(),
        AIS:getDefaultAisParams()
    }
} 
